<template>
	<div class="product_link_variant arrow-target" :class="{'is-active':isDragover}"
	     :id="item.id" @drop="drop"
	     @dragover="dragOver" @dragenter="dragEnter" @dragleave="dragLeave" :data-index="dataIndex">
		<div class="left">
			<div class="img_wrpr" v-if="findOptImage">
				<img :src="findOptImage">
			</div>
			<div class="img_wrpr" v-else>
				<img class="placeholder-img" :src="require('@/assets/img/placeholder-img.svg')">
			</div>
			<h3 :id="item.id" v-if="item.title.length >= 30"
			    v-tippy="{theme:'small',placement:'top-start',distance:'-22',maxWidth:600,boundary:'window',animation:'fade'}"
			    :content="item.title" class="item_title __long" >
				{{item.title}}
			</h3>
			<h3 :id="item.id" v-else class="item_title">{{item.title}}</h3>
		</div>
	</div>
</template>

<script>

export default {
  components: {},
  props: ['item', 'dataIndex', 'findOptImage' ],
	data() {
    	return {
    		isDragover: false,
	    }
	},
	methods: {
		drop ( event ) {
			event.preventDefault();
			this.isDragover = false;
			this.$emit('drop', event);
		},
		dragOver ( event ) {
			this.isDragover = true;
			this.$emit('dragover', event);
		},
		dragEnter ( event ) {
			this.isDragover = true;
		},
		dragLeave ( event ) {
			this.isDragover = false;
		}
	}
}
</script>
<style lang="scss" scoped>
.product_link_variant {
	.left {
		pointer-events: none;
		.img_wrpr {
			pointer-events: none;
		}
	}
	.item_title {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		pointer-events: none;

		&.__long {
			* {
				pointer-events: none;
			}
			pointer-events: auto;
		}
	}
	&.is-active {
		box-shadow: 0 0 0 1px $blue;
	}
	.product_link_variant {
		cursor: grab;
		transition-property: box-shadow;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
	}
}
</style>
